.page {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  gap: var(--sp-6);
  max-width: 780px;
  margin: 0 auto;
  padding: var(--sp-7) var(--sp-6) var(--sp-8);
  background: var(--bg);
  color: var(--text);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--sp-5);
}

/* Заголовок распирает шапку, поэтому кнопка возврата и аккаунт стоят у
   правого края — там же, где на планировщике и в «Моих поездках». */
.title {
  flex: 1;
  min-width: 0;
  font-size: var(--fs-xl);
  font-weight: 600;
}

.lede {
  max-width: 60ch;
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-lg);
}

/* ── Форма ───────────────────────────────────────────────────────────────── */

.form {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-6);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

.formLede {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-md);
}

.label {
  color: var(--text-3);
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.textarea {
  width: 100%;
  padding: var(--sp-4);
  background: var(--bg);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius);
  color: var(--text);
  font: inherit;
  font-size: var(--fs-md);
  line-height: 1.5;
  resize: vertical;
}

/* Два поля в ряд, но на узком экране — друг под другом: выпадашка стран с
   длинными названиями в половине телефона нечитаема. */
.formRow {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--sp-5);
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
  min-width: 0;
}

.select {
  width: 100%;
  padding: var(--sp-3) var(--sp-4);
  background: var(--bg);
  border: var(--bw) solid var(--border-strong);
  border-radius: var(--radius);
  color: var(--text);
  font: inherit;
  font-size: var(--fs-md);
}

.formFoot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--sp-5);
}

.counter {
  color: var(--text-3);
  font-size: var(--fs-sm);
  font-variant-numeric: tabular-nums;
}

.formHint {
  margin: 0;
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.error {
  margin: 0;
  color: var(--error);
  font-size: var(--fs-sm);
}

.sent {
  margin: 0;
  color: var(--ok);
  font-size: var(--fs-sm);
}

/* ── Фильтры ─────────────────────────────────────────────────────────────── */

.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3);
}

.filterRight {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.filterRight .select {
  width: auto;
  max-width: 15rem;
}

.chip {
  padding: var(--sp-3) var(--sp-5);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  color: var(--text-2);
  font-size: var(--fs-sm);
  cursor: pointer;
}

.chip:hover {
  background: var(--surface-2);
  color: var(--text);
}

.chipOn {
  background: var(--surface-2);
  border-color: var(--border-strong);
  color: var(--text);
  font-weight: 600;
}

/* ── Список ──────────────────────────────────────────────────────────────── */

.list {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
  padding: var(--sp-5) var(--sp-6);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}

/* Перенос строк из текста сохраняется: в совет часто входит короткий список,
   и склеенный в абзац он теряет смысл. */
.text {
  margin: 0;
  font-size: var(--fs-md);
  line-height: 1.55;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-3);
  font-size: var(--fs-sm);
}

/* Распорка: всё, что до неё, — про сам совет, всё после — действия над ним. */
.metaGap {
  flex: 1 1 auto;
}

.tag {
  padding: var(--sp-1) var(--sp-3);
  background: var(--surface-2);
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-xs);
}

/* Статус виден только автору и только у неопубликованного — пунктир тот же,
   что у «в работе» на тарифах: обещанное, но пока не существующее. */
.tagStatus {
  background: transparent;
  border: var(--bw) dashed var(--border-strong);
  color: var(--text-3);
}

/* «От редакции» — тот же тег, но обведённый: знак происхождения, а не имя.
   Своего цвета у него намеренно нет — редакционный совет не важнее совета
   живого человека, он просто написан не им. */
.tagEditorial {
  border: var(--bw) solid var(--border-strong);
  color: var(--text-2);
  font-weight: 600;
}

.author {
  color: var(--text-2);
}

/* Язык, на котором показан текст, когда перевода на язык интерфейса нет.
   Подпись того же веса, что дата: это сноска о том, что читатель и так видит
   глазами, а не предупреждение. */
.langNote {
  color: var(--text-3);
}

.date {
  color: var(--text-3);
}

.linkBtn {
  padding: 0;
  background: none;
  border: 0;
  color: var(--text-3);
  font: inherit;
  font-size: var(--fs-sm);
  cursor: pointer;
  text-decoration: underline;
}

.linkBtn:hover {
  color: var(--error);
}

/* Подтверждение — счётчик с галкой, а не слово: слово пришлось бы согласовывать
   с числом на пяти языках ради строки, которую и так читают как «сколько». */
.confirm {
  display: inline-flex;
  align-items: center;
  gap: var(--sp-2);
  padding: var(--sp-2) var(--sp-4);
  background: var(--surface);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  color: var(--text-2);
  font: inherit;
  font-size: var(--fs-sm);
  cursor: pointer;
}

.confirm:hover {
  background: var(--surface-2);
  color: var(--text);
}

.confirmOn {
  background: color-mix(in srgb, var(--ok) 12%, var(--surface));
  border-color: var(--ok);
  color: var(--ok);
  font-weight: 600;
}

.confirmCount {
  font-variant-numeric: tabular-nums;
}

.empty {
  margin: 0;
  padding: var(--sp-7) 0;
  color: var(--text-3);
  font-size: var(--fs-md);
  text-align: center;
}

/* ── Подвал ──────────────────────────────────────────────────────────────── */

.footer {
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding-top: var(--sp-5);
  border-top: var(--bw) solid var(--border);
}

.back {
  color: var(--text-3);
  font-size: var(--fs-sm);
}

/* ── Узкий экран ─────────────────────────────────────────────────────────── */

@media (max-width: 720px) {
  .formRow {
    grid-template-columns: minmax(0, 1fr);
  }

  .filters {
    align-items: stretch;
    flex-direction: column;
  }

  .filterRight .select {
    flex: 1 1 auto;
    max-width: none;
  }
}
